<template>
  <c-form @submit.prevent="submit">

    <c-title>Passwort vergessen</c-title>

    <c-form-input
      id="email"
      :errors="[{
        message: 'Dieses Feld ist erforderlich.',
        show: !$v.email.required
      }, {
        message: 'Keine gültige E-Mail-Adresse.',
        show: !$v.email.email
      }]"
      :has-error="$v.email.$error"
      :is-valid="!$v.email.$invalid"
      v-model="email"
      aria-required="true"
      autocomplete="username"
      label="E-Mail-Adresse"
      type="email"
      @input="$v.email.$touch"
    />

    <c-button :busy="saveStatus === $config.status.SAVING">
      Zurücksetzen
    </c-button>

    <router-link :to="{ name: 'login' }">
      Zum Login
    </router-link>

  </c-form>
</template>

<script>
import CButton from '@/components/CButton'
import CForm from '@/components/form/CForm'
import CFormInput from '@/components/form/CFormInput'
import CTitle from '@/components/CTitle'

import handleRequestError from '@/functions/handleRequestError'
import { email, required } from 'vuelidate/lib/validators'

export default {
  name: 'VResetPassword',

  components: {
    CButton,
    CForm,
    CFormInput,
    CTitle
  },

  data () {
    return {
      saveStatus: this.$config.status.IDLE,
      email: ''
    }
  },

  validations: {
    email: {
      required,
      email
    }
  },

  methods: {
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$store.commit('notifications/add', {
          text: 'Bitte füllen Sie alle Felder korrekt aus.',
          type: 'error'
        })

        return
      }

      this.saveStatus = this.$config.status.SAVING

      this.$api.post('auth/confirm/', { email: this.email })
        .then(response => {
          this.email = ''
          this.$store.commit('notifications/add', {
            text: 'Sie erhalten in Kürze eine E-Mail, um Ihr Passwort zurückzusetzen.',
            type: 'success'
          })
          this.$router.push({ name: 'login' })
        })
        .catch(error => {
          handleRequestError({
            error,
            fallback: 'Ihr Passwort kann zurzeit leider nicht zurückgesetzt werden. Bitte versuchen Sie es später erneut.'
          })

          this.saveStatus = this.$config.status.ERROR
        })
    }
  }
}
</script>
